const status = {
  1: 'Borrador',
  2: 'Solicitada',
  3: 'Auditada',
  4: 'Observada',
  5: 'Procesada',
  6: 'Factura Pendiente',
  7: 'Factura Pedida',
  8: 'Factura Presentada',
  9: 'Anulada',
  10: 'Fuera de Término',
}

const getStatusName = id => (
  status[id] || null
)

const getStatusId = name => (
  Object.keys(status).find(key => status[key] === name)
)

export { status, getStatusName, getStatusId }